export const captchaFailureRecoveryPopupConstant = {
  title: 'Having trouble signing up?',
  description: 'Use your Google account to continue, or raise a ticket if you need help.',
  googleCta: 'Sign up with Google',
  googleCtaId: 'recovery-google-signup-btn',
  commonCta: 'Raise a ticket',
  commonCtaId: 'recovery-support-ticket-btn'
};
